import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _39817acc = () => interopDefault(import('../pages/start-teaching/index.vue' /* webpackChunkName: "pages/start-teaching/index" */))
const _5a724f8a = () => interopDefault(import('../pages/start-teaching/email-registered.vue' /* webpackChunkName: "pages/start-teaching/email-registered" */))
const _efd6ecea = () => interopDefault(import('../pages/start-teaching/register.vue' /* webpackChunkName: "pages/start-teaching/register" */))
const _afa253e8 = () => interopDefault(import('../pages/start-teaching/steps/certificates.vue' /* webpackChunkName: "pages/start-teaching/steps/certificates" */))
const _c92b56d0 = () => interopDefault(import('../pages/start-teaching/steps/documents.vue' /* webpackChunkName: "pages/start-teaching/steps/documents" */))
const _c16bda3c = () => interopDefault(import('../pages/start-teaching/steps/education-degrees.vue' /* webpackChunkName: "pages/start-teaching/steps/education-degrees" */))
const _323afcba = () => interopDefault(import('../pages/start-teaching/steps/intro-video.vue' /* webpackChunkName: "pages/start-teaching/steps/intro-video" */))
const _2455707b = () => interopDefault(import('../pages/start-teaching/steps/languages.vue' /* webpackChunkName: "pages/start-teaching/steps/languages" */))
const _e574070a = () => interopDefault(import('../pages/start-teaching/steps/personal-info.vue' /* webpackChunkName: "pages/start-teaching/steps/personal-info" */))
const _526cc88c = () => interopDefault(import('../pages/start-teaching/steps/profile-picture.vue' /* webpackChunkName: "pages/start-teaching/steps/profile-picture" */))
const _4a4b8ac2 = () => interopDefault(import('../pages/start-teaching/steps/teacher-about.vue' /* webpackChunkName: "pages/start-teaching/steps/teacher-about" */))
const _10735388 = () => interopDefault(import('../pages/start-teaching/steps/teaching-courses.vue' /* webpackChunkName: "pages/start-teaching/steps/teaching-courses" */))
const _75cb9e99 = () => interopDefault(import('../pages/start-teaching/steps/teaching-price.vue' /* webpackChunkName: "pages/start-teaching/steps/teaching-price" */))
const _bbd0acf2 = () => interopDefault(import('../pages/start-teaching/steps/tracking.vue' /* webpackChunkName: "pages/start-teaching/steps/tracking" */))
const _9ed8d946 = () => interopDefault(import('../pages/start-teaching/steps/work-experiences.vue' /* webpackChunkName: "pages/start-teaching/steps/work-experiences" */))
const _46dea396 = () => interopDefault(import('../pages/start-teaching/steps/worktimes.vue' /* webpackChunkName: "pages/start-teaching/steps/worktimes" */))
const _9fea77ee = () => interopDefault(import('../pages/start-teaching/ticket/list.vue' /* webpackChunkName: "pages/start-teaching/ticket/list" */))
const _bae233f6 = () => interopDefault(import('../pages/start-teaching/ticket/new.vue' /* webpackChunkName: "pages/start-teaching/ticket/new" */))
const _b3fd0f8a = () => interopDefault(import('../pages/start-teaching/ticket/view/_id.vue' /* webpackChunkName: "pages/start-teaching/ticket/view/_id" */))
const _4cc0f2ae = () => interopDefault(import('../../config/pages/auth/forget-password.vue' /* webpackChunkName: "pages/auth/forget-password" */))
const _16a9dc17 = () => interopDefault(import('../../config/pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _615e85c7 = () => interopDefault(import('../../config/pages/auth/login-by-oauth.vue' /* webpackChunkName: "pages/auth/login-by-oauth" */))
const _0ba2af4c = () => interopDefault(import('../../config/pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _d75d9830 = () => interopDefault(import('../../config/pages/auth/set-password.vue' /* webpackChunkName: "pages/auth/set-password" */))
const _0aeb93da = () => interopDefault(import('../../config/pages/auth/signup.vue' /* webpackChunkName: "pages/auth/signup" */))
const _286bda8a = () => interopDefault(import('../../config/pages/auth/verify.vue' /* webpackChunkName: "pages/auth/verify" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en/start-teaching",
    component: _39817acc,
    name: "start-teaching___en"
  }, {
    path: "/en/start-teaching/email-registered",
    component: _5a724f8a,
    name: "start-teaching-email-registered___en"
  }, {
    path: "/en/start-teaching/register",
    component: _efd6ecea,
    name: "start-teaching-register___en"
  }, {
    path: "/en/start-teaching/steps/certificates",
    component: _afa253e8,
    name: "start-teaching-steps-certificates___en"
  }, {
    path: "/en/start-teaching/steps/documents",
    component: _c92b56d0,
    name: "start-teaching-steps-documents___en"
  }, {
    path: "/en/start-teaching/steps/education-degrees",
    component: _c16bda3c,
    name: "start-teaching-steps-education-degrees___en"
  }, {
    path: "/en/start-teaching/steps/intro-video",
    component: _323afcba,
    name: "start-teaching-steps-intro-video___en"
  }, {
    path: "/en/start-teaching/steps/languages",
    component: _2455707b,
    name: "start-teaching-steps-languages___en"
  }, {
    path: "/en/start-teaching/steps/personal-info",
    component: _e574070a,
    name: "start-teaching-steps-personal-info___en"
  }, {
    path: "/en/start-teaching/steps/profile-picture",
    component: _526cc88c,
    name: "start-teaching-steps-profile-picture___en"
  }, {
    path: "/en/start-teaching/steps/teacher-about",
    component: _4a4b8ac2,
    name: "start-teaching-steps-teacher-about___en"
  }, {
    path: "/en/start-teaching/steps/teaching-courses",
    component: _10735388,
    name: "start-teaching-steps-teaching-courses___en"
  }, {
    path: "/en/start-teaching/steps/teaching-price",
    component: _75cb9e99,
    name: "start-teaching-steps-teaching-price___en"
  }, {
    path: "/en/start-teaching/steps/tracking",
    component: _bbd0acf2,
    name: "start-teaching-steps-tracking___en"
  }, {
    path: "/en/start-teaching/steps/work-experiences",
    component: _9ed8d946,
    name: "start-teaching-steps-work-experiences___en"
  }, {
    path: "/en/start-teaching/steps/worktimes",
    component: _46dea396,
    name: "start-teaching-steps-worktimes___en"
  }, {
    path: "/en/start-teaching/ticket/list",
    component: _9fea77ee,
    name: "start-teaching-ticket-list___en"
  }, {
    path: "/en/start-teaching/ticket/new",
    component: _bae233f6,
    name: "start-teaching-ticket-new___en"
  }, {
    path: "/en/start-teaching/ticket/view/:id?",
    component: _b3fd0f8a,
    name: "start-teaching-ticket-view-id___en"
  }, {
    path: "/en/auth/forget-password",
    component: _4cc0f2ae,
    name: "auth-forget-password___en"
  }, {
    path: "/en/auth/login",
    component: _16a9dc17,
    name: "auth-login___en"
  }, {
    path: "/en/auth/login-by-oauth",
    component: _615e85c7,
    name: "auth-login-by-oauth___en"
  }, {
    path: "/en/auth/logout",
    component: _0ba2af4c,
    name: "auth-logout___en"
  }, {
    path: "/en/auth/set-password",
    component: _d75d9830,
    name: "auth-set-password___en"
  }, {
    path: "/en/auth/signup",
    component: _0aeb93da,
    name: "auth-signup___en"
  }, {
    path: "/en/auth/verify",
    component: _286bda8a,
    name: "auth-verify___en"
  }, {
    path: "/fr/auth/forget-password",
    component: _4cc0f2ae,
    name: "auth-forget-password___fr"
  }, {
    path: "/fr/auth/login",
    component: _16a9dc17,
    name: "auth-login___fr"
  }, {
    path: "/fr/auth/login-by-oauth",
    component: _615e85c7,
    name: "auth-login-by-oauth___fr"
  }, {
    path: "/fr/auth/logout",
    component: _0ba2af4c,
    name: "auth-logout___fr"
  }, {
    path: "/fr/auth/set-password",
    component: _d75d9830,
    name: "auth-set-password___fr"
  }, {
    path: "/fr/auth/signup",
    component: _0aeb93da,
    name: "auth-signup___fr"
  }, {
    path: "/fr/auth/verify",
    component: _286bda8a,
    name: "auth-verify___fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
